import registrationPlans from "@/models/loyaltyPanel/subscriptions/RegistrationPlans";
import CompanySubscriptionPlan from "@/models/loyaltyPanel/subscriptions/CompanySubscriptionPlan";
import isEmpty from "lodash/isEmpty";

export default {
    namespaced: true,

    state: () => ({
        registrationPlans: [],
        planTypes: [],
        rewardTypes: [],
        subscriptionPlan: new registrationPlans(),
        companySubscriptionPlan: new CompanySubscriptionPlan(),
        storeAttributes: [],
        companyAttributes: [],
        companyPermissions: {},
        storePermissions: {},
        companyDialog: false
    }),

    mutations: {
        setRegistrationPlans(state, payload) {
            state.registrationPlans = payload;
        },
        setPlanTypes(state, payload) {
            state.planTypes = payload;
        },
        setRewardTypes(state, payload) {
            state.rewardTypes = payload;
        },
        setSubscriptionPlan(state, payload) {
            state.subscriptionPlan = new registrationPlans(payload);
        },
        setStoreAttributes(state, payload) {
            state.storeAttributes = payload;
        },
        setCompanyAttributes(state, payload) {
            state.companyAttributes = payload;
        },
        setCompanySubscriptionPlan(state, payload) {
            state.companySubscriptionPlan = new CompanySubscriptionPlan(payload);
        },
        setCompanyPermissions(state, payload) {
            state.companyPermissions = payload
        },
        setStorePermissions(state, payload) {
            state.storePermissions = payload
        },
        setCompanyDialog(state, payload) {
            state.companyDialog = payload;
        },
    },

    actions: {
        async getRegistrationPlans({ commit },query){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await registrationPlans.get(query);
                const { results, pagination } = data.data;
                
                commit("setRegistrationPlans", results);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getRegistrationPlanProfile({ commit }, id){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await registrationPlans.getProfile(id);
                let item = data.data
                item.reward_type_id = item.reward_type.reward_type_id
                let paymentMethodsIds = []
                item.store_payment_methods.map(method => {
                    paymentMethodsIds.push(method.store_payment_method_id)
                })
                item.store_payment_methods = paymentMethodsIds
                
                if(item.extra_properties.is_brand) {
                    commit("setCompanySubscriptionPlan", item);
                    commit("setCompanyDialog", true);
                    commit("setCompanyPermissions", item.permissions)
                } else {
                    commit("setSubscriptionPlan", item);
                    commit("setStorePermissions", item.permissions);
                    commit("setDialog", true, { root: true });
                }
                
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getPlanTypes({ commit }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await registrationPlans.getPlanTypes();
                commit("setPlanTypes", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getStoreAttributes({ commit }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await registrationPlans.getStoreAttributes();
                commit("setStoreAttributes", data.data.attributes);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getCompanyAttributes({ commit }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await CompanySubscriptionPlan.getCompanyAttributes();
                commit("setCompanyAttributes", data.data.attributes);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getCompanyPermissions({ commit }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await registrationPlans.getPermissions();
                commit("setCompanyPermissions", data.data.default_company_cms);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getStorePermissions({ commit }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await registrationPlans.getPermissions();
                commit("setStorePermissions", data.data.default_store_cms);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getRewardTypes({ commit }){
            try {
                commit("setLoading", true, { root: true });
                const { data } = await registrationPlans.getRewardTypes();
                commit("setRewardTypes", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async create({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });

                let subscriptionPlan = { ...state.subscriptionPlan };
                delete subscriptionPlan.store_subscription_plan_id;
                subscriptionPlan.permissions = state.storePermissions
                if(isEmpty(subscriptionPlan.attributes)) {
                    delete subscriptionPlan.attributes;
                }

                await registrationPlans.create(subscriptionPlan);
                
                dispatch("getRegistrationPlans","?page=1")
                commit("setSubscriptionPlan",{})
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created Subscription Plan!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async createCompanySubscriptionPlan({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });

                let subscriptionPlan = { ...state.companySubscriptionPlan };
                delete subscriptionPlan.store_subscription_plan_id;
                subscriptionPlan.permissions = state.companyPermissions

                await CompanySubscriptionPlan.create(subscriptionPlan);
                
                dispatch("getRegistrationPlans","?page=1")
                commit("setCompanySubscriptionPlan",{})
                commit("setLoading", false, { root: true });
                commit("setCompanyDialog", false);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created Company Subscription Plan!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async updateCompanySubscriptionPlan({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });
                let subscriptionPlan = { ...state.companySubscriptionPlan };
                let id = subscriptionPlan.store_subscription_plan_id;
                delete subscriptionPlan.store_subscription_plan_id;
                subscriptionPlan.permissions = state.companyPermissions
                await registrationPlans.updateCompany(subscriptionPlan,id)
                
                dispatch("getRegistrationPlans","?page=1")
                commit("setCompanySubscriptionPlan",{})
                commit("setLoading", false, { root: true });
                commit("setCompanyDialog",  false);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated Subscription Plan!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async update({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });
                let subscriptionPlan = { ...state.subscriptionPlan };
                let id = subscriptionPlan.store_subscription_plan_id
                delete subscriptionPlan.store_subscription_plan_id;
                subscriptionPlan.permissions = state.storePermissions

                await registrationPlans.update(subscriptionPlan,id);
                
                dispatch("getRegistrationPlans","?page=1")
                commit("setSubscriptionPlan",{})
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated Subscription Plan!"
                    },
                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async removeRegistrationPlan({ commit, state, dispatch }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                await registrationPlans.delete(id);

                dispatch("getRegistrationPlans","?page=1")
                commit("setLoading", false, { root: true });
                commit("setDeleteDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully deleted Registration Plan!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        }
        
    }
        
};
